module.exports = __webpack_public_path__ + "static/media/mulesoft.d379a1b5.avif";